(function () {
  var GLASSES_FORM_SELECTOR = '#la-prescription-form.ciw-la-manual-rx-form--mobile';
  var CONTACT_FORM_SELECTOR = '#la-prescription-form.ciw-la-contact-rx-form--mobile';
  var STYLE_ID = 'ciw-la-rx-select-styles';
  var BORDER = '1px solid #d1d5db';
  var ORANGE = '#f99511';
  var HOVER_BG = '#f3f4f6';
  var openWrap = null;

  function setImportant(el, prop, value) {
    if (el && el.style) {
      el.style.setProperty(prop, value, 'important');
    }
  }

  function applyMenuScrollStyles(menuScroll, isDropUp) {
    if (!menuScroll) {
      return;
    }

    setImportant(menuScroll, 'max-height', '180px');
    setImportant(menuScroll, 'overflow-y', 'auto');
    setImportant(menuScroll, 'overscroll-behavior', 'contain');
    setImportant(menuScroll, 'margin', '0');
    setImportant(menuScroll, 'padding', '0');
    setImportant(menuScroll, 'border-radius', '0');
    setImportant(menuScroll, 'background', '#fff');
    setImportant(menuScroll, 'box-shadow', 'none');
    setImportant(menuScroll, 'box-sizing', 'border-box');
    setImportant(menuScroll, 'border-left', BORDER);
    setImportant(menuScroll, 'border-right', BORDER);

    if (isDropUp) {
      setImportant(menuScroll, 'border-top', BORDER);
      setImportant(menuScroll, 'border-bottom', '0');
    } else {
      setImportant(menuScroll, 'border-top', '0');
      setImportant(menuScroll, 'border-bottom', BORDER);
    }
  }

  function applyMenuShellStyles(menu) {
    if (!menu) {
      return;
    }

    var isDropUp = menu.classList.contains('ciw-la-rx-select__menu--drop-up');
    var menuScroll = menu.querySelector('.ciw-la-rx-select__menu-scroll');

    setImportant(menu, 'margin', '0');
    setImportant(menu, 'padding', '0');
    setImportant(menu, 'border-radius', '0');
    setImportant(menu, 'background', '#fff');
    setImportant(menu, 'box-shadow', 'none');
    setImportant(menu, 'box-sizing', 'border-box');
    setImportant(menu, 'overflow', 'hidden');
    setImportant(menu, 'border-left', BORDER);
    setImportant(menu, 'border-right', BORDER);

    if (isDropUp) {
      setImportant(menu, 'border-top', BORDER);
      setImportant(menu, 'border-bottom', '0');
      setImportant(menu, 'margin-top', '0');
    } else {
      setImportant(menu, 'border-top', '0');
      setImportant(menu, 'border-bottom', BORDER);
      setImportant(menu, 'margin-top', '-1px');
    }

    applyMenuScrollStyles(menuScroll, isDropUp);
  }

  function applyOptionStyles(optionBtn) {
    if (!optionBtn) {
      return;
    }

    var isSelected = optionBtn.classList.contains('is-selected');
    var labelEl = optionBtn.querySelector('.ciw-la-rx-select__option-label');
    var checkEl = optionBtn.querySelector('.ciw-la-rx-select__option-check');

    setImportant(optionBtn, 'display', 'flex');
    setImportant(optionBtn, 'align-items', 'center');
    setImportant(optionBtn, 'justify-content', 'center');
    setImportant(optionBtn, 'position', 'relative');
    setImportant(optionBtn, 'width', '100%');
    setImportant(optionBtn, 'min-height', '36px');
    setImportant(optionBtn, 'margin', '0');
    setImportant(optionBtn, 'padding', '8px 28px 8px 10px');
    setImportant(optionBtn, 'border', '0');
    setImportant(optionBtn, 'border-bottom', '0');
    setImportant(optionBtn, 'border-radius', '0');
    setImportant(optionBtn, 'background', '#fff');
    setImportant(optionBtn, 'box-shadow', 'none');
    setImportant(optionBtn, 'font-family', 'Inter, Arial, sans-serif');
    setImportant(optionBtn, 'font-size', '14px');
    setImportant(optionBtn, 'line-height', '1.2');
    setImportant(optionBtn, 'text-align', 'center');
    setImportant(optionBtn, 'cursor', 'pointer');
    setImportant(optionBtn, 'box-sizing', 'border-box');
    setImportant(optionBtn, '-webkit-appearance', 'none');
    setImportant(optionBtn, 'appearance', 'none');

    if (labelEl) {
      setImportant(labelEl, 'flex', '0 1 auto');
      setImportant(labelEl, 'min-width', '0');
      setImportant(labelEl, 'font-weight', isSelected ? '600' : '400');
      setImportant(labelEl, 'color', isSelected ? ORANGE : '#374151');
    }

    if (checkEl) {
      setImportant(checkEl, 'display', isSelected ? 'block' : 'none');
      setImportant(checkEl, 'position', 'absolute');
      setImportant(checkEl, 'right', '10px');
      setImportant(checkEl, 'top', '50%');
      setImportant(checkEl, 'transform', 'translateY(-50%)');
      setImportant(checkEl, 'font-size', '14px');
      setImportant(checkEl, 'font-weight', '700');
      setImportant(checkEl, 'line-height', '1');
      setImportant(checkEl, 'color', ORANGE);
    }
  }

  function getForm() {
    return (
      document.querySelector(GLASSES_FORM_SELECTOR) ||
      document.querySelector(CONTACT_FORM_SELECTOR)
    );
  }

  function ensureStyles() {
    var style = document.getElementById(STYLE_ID);
    if (!style) {
      style = document.createElement('style');
      style.id = STYLE_ID;
      (document.body || document.head).appendChild(style);
    }

    style.textContent =
      '#lensadvizor-prescription-modal .ciw-la-rx-select{position:relative;display:block;width:100%;min-width:0}' +
      '#lensadvizor-prescription-modal .ciw-la-rx-select__native{position:absolute;width:1px;height:1px;margin:-1px;padding:0;border:0;clip:rect(0 0 0 0);overflow:hidden;white-space:nowrap}' +
      '#lensadvizor-prescription-modal .ciw-la-rx-select__trigger{position:relative;display:flex;align-items:center;justify-content:center;width:100%;min-height:44px;margin:0;padding:0 28px;border:0;border-radius:0;background:transparent;font-family:Inter,Arial,sans-serif;font-size:14px;font-weight:400;line-height:1.2;color:#374151;text-align:center;cursor:pointer;box-sizing:border-box;-webkit-tap-highlight-color:transparent}' +
      '#lensadvizor-prescription-modal .ciw-la-rx-select__value{flex:1 1 auto;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;text-align:center}' +
      '#lensadvizor-prescription-modal .ciw-la-rx-select__chevron{position:absolute;right:10px;top:50%;transform:translateY(-50%);width:10px;height:6px;background-image:url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'10\' height=\'6\' viewBox=\'0 0 10 6\' fill=\'none\'%3E%3Cpath d=\'M1 1L5 5L9 1\' stroke=\'%239ca3af\' stroke-width=\'1.5\' stroke-linecap=\'round\' stroke-linejoin=\'round\'/%3E%3C/svg%3E");background-repeat:no-repeat;background-position:center;background-size:contain}' +
      '#lensadvizor-prescription-modal .ciw-la-rx-select--disabled .ciw-la-rx-select__trigger,#lensadvizor-prescription-modal .ciw-la-rx-grid__col--disabled .ciw-la-rx-select__trigger{color:#9ca3af;cursor:default;pointer-events:none}' +
      '#lensadvizor-prescription-modal .ciw-la-rx-select--open{z-index:40}' +
      '#lensadvizor-prescription-modal :is(.ciw-la-rx-grid__col,.ciw-la-rx-grid__col-field,.ciw-la-pd-split__field,.ciw-la-pd-dual-split__field):has(.ciw-la-rx-select--open){position:relative;z-index:40;overflow:visible}' +
      '#lensadvizor-prescription-modal .ciw-la-pd-split__field .ciw-la-rx-select__trigger{min-height:44px;padding:0 28px}' +
      '#lensadvizor-prescription-modal .ciw-la-pd-split:not(.ciw-la-pd-split--dual) .ciw-la-pd-split__field .ciw-la-rx-select__trigger{padding:0 20px 0 6px;justify-content:center;text-align:center}' +
      '#lensadvizor-prescription-modal .ciw-la-pd-split:not(.ciw-la-pd-split--dual) .ciw-la-pd-split__field .ciw-la-rx-select__value{flex:0 1 auto;overflow:visible;text-overflow:clip;text-align:center}' +
      '#lensadvizor-prescription-modal .ciw-la-pd-dual-split__field .ciw-la-rx-select{height:100%}' +
      '#lensadvizor-prescription-modal .ciw-la-pd-dual-split__field .ciw-la-rx-select__trigger{height:100%;min-height:56px;padding:17px 28px 7px;justify-content:center;text-align:center}' +
      '#lensadvizor-prescription-modal .ciw-la-pd-dual-split__field .ciw-la-rx-select__value{text-align:center}' +
      'body.template-product.la-modal-open:has(.ciw-pdp) .ciw-la-rx-select__menu,.ciw-la-rx-select__menu{position:fixed!important;z-index:10000004!important;margin:0!important;padding:0!important;border-left:1px solid #d1d5db!important;border-right:1px solid #d1d5db!important;border-radius:0!important;background:#fff!important;box-shadow:none!important;box-sizing:border-box!important;overflow:hidden!important}' +
      'body.template-product.la-modal-open:has(.ciw-pdp) .ciw-la-rx-select__menu:not(.ciw-la-rx-select__menu--drop-up),.ciw-la-rx-select__menu:not(.ciw-la-rx-select__menu--drop-up){border-top:0!important;border-bottom:1px solid #d1d5db!important;margin-top:-1px!important}' +
      'body.template-product.la-modal-open:has(.ciw-pdp) .ciw-la-rx-select__menu--drop-up,.ciw-la-rx-select__menu--drop-up{border-top:1px solid #d1d5db!important;border-bottom:0!important;margin-top:0!important}' +
      'body.template-product.la-modal-open:has(.ciw-pdp) .ciw-la-rx-select__menu-scroll,.ciw-la-rx-select__menu-scroll{max-height:180px!important;overflow-y:auto!important;overscroll-behavior:contain!important;-webkit-overflow-scrolling:touch;margin:0!important;padding:0!important;border-left:1px solid #d1d5db!important;border-right:1px solid #d1d5db!important;border-radius:0!important;background:#fff!important;box-shadow:none!important;box-sizing:border-box!important}' +
      'body.template-product.la-modal-open:has(.ciw-pdp) .ciw-la-rx-select__menu:not(.ciw-la-rx-select__menu--drop-up) .ciw-la-rx-select__menu-scroll,.ciw-la-rx-select__menu:not(.ciw-la-rx-select__menu--drop-up) .ciw-la-rx-select__menu-scroll{border-top:0!important;border-bottom:1px solid #d1d5db!important}' +
      'body.template-product.la-modal-open:has(.ciw-pdp) .ciw-la-rx-select__menu--drop-up .ciw-la-rx-select__menu-scroll,.ciw-la-rx-select__menu--drop-up .ciw-la-rx-select__menu-scroll{border-top:1px solid #d1d5db!important;border-bottom:0!important}' +
      'body.template-product.la-modal-open:has(.ciw-pdp) .ciw-la-rx-select__option,.ciw-la-rx-select__option{display:flex!important;align-items:center!important;justify-content:center!important;position:relative!important;width:100%!important;min-height:36px!important;margin:0!important;padding:8px 28px 8px 10px!important;border:0!important;border-bottom:0!important;border-radius:0!important;background:#fff!important;box-shadow:none!important;font-family:Inter,Arial,sans-serif!important;font-size:14px!important;line-height:1.2!important;text-align:center!important;cursor:pointer!important;box-sizing:border-box!important;-webkit-appearance:none!important;appearance:none!important}' +
      'body.template-product.la-modal-open:has(.ciw-pdp) .ciw-la-rx-select__option-label,.ciw-la-rx-select__option-label{flex:0 1 auto;min-width:0;font-weight:400;color:#374151}' +
      'body.template-product.la-modal-open:has(.ciw-pdp) .ciw-la-rx-select__option-check,.ciw-la-rx-select__option-check{display:none;position:absolute;right:10px;top:50%;transform:translateY(-50%);font-size:14px;font-weight:700;line-height:1;color:' + ORANGE + '}' +
      'body.template-product.la-modal-open:has(.ciw-pdp) .ciw-la-rx-select__option:hover,.ciw-la-rx-select__option:hover{background:' + HOVER_BG + '!important}' +
      'body.template-product.la-modal-open:has(.ciw-pdp) .ciw-la-rx-select__option.is-selected .ciw-la-rx-select__option-label,.ciw-la-rx-select__option.is-selected .ciw-la-rx-select__option-label{font-weight:600!important;color:' + ORANGE + '!important}' +
      'body.template-product.la-modal-open:has(.ciw-pdp) .ciw-la-rx-select__option.is-selected .ciw-la-rx-select__option-check,.ciw-la-rx-select__option.is-selected .ciw-la-rx-select__option-check{display:block!important}' +
      'body.template-product.la-modal-open:has(.ciw-pdp) .ciw-la-rx-select__option:active,.ciw-la-rx-select__option:active{background:' + HOVER_BG + '!important}' +
      '@media screen and (max-width:749px){' +
      '#lensadvizor-prescription-modal .ciw-la-rx-grid--eye-with-add .ciw-la-rx-select__trigger{justify-content:flex-start;padding:0 12px 0 10px;text-align:left}' +
      '#lensadvizor-prescription-modal .ciw-la-rx-grid--eye-with-add .ciw-la-rx-select__value{text-align:left}' +
      '#lensadvizor-prescription-modal #la-prescription-form.ciw-la-manual-rx-form--mobile:has(.ciw-la-rx-grid--eye-with-add) .ciw-la-pd-split__field .ciw-la-rx-select__trigger{justify-content:flex-start;padding:0 12px 0 10px;text-align:left}' +
      '#lensadvizor-prescription-modal #la-prescription-form.ciw-la-manual-rx-form--mobile:has(.ciw-la-rx-grid--eye-with-add) .ciw-la-pd-split__field .ciw-la-rx-select__value{text-align:left}' +
      '}';
  }

  function isEnhanceableSelect(select) {
    if (!select || select.tagName !== 'SELECT') {
      return false;
    }
    if (select.closest('.ciw-la-prism-native-pending')) {
      return false;
    }
    if (select.closest('.ciw-la-manual-rx-hidden')) {
      return false;
    }
    var form = getForm();
    return !!(form && form.contains(select));
  }

  function getDisplayText(select) {
    var opt = select.options[select.selectedIndex];
    if (!opt || opt.value === '' || opt.value === '0') {
      return 'None';
    }
    var text = (opt.textContent || '').trim();
    return text || 'None';
  }

  function getModalRoot() {
    return document.getElementById('lensadvizor-prescription-modal') || document.body;
  }

  function getWrapMenu(wrap) {
    return wrap && wrap._ciwRxMenu ? wrap._ciwRxMenu : null;
  }

  function closeMenu(wrap) {
    if (!wrap) {
      wrap = openWrap;
    }
    if (!wrap) {
      return;
    }

    var menu = getWrapMenu(wrap) || wrap.querySelector('.ciw-la-rx-select__menu');
    var trigger = wrap.querySelector('.ciw-la-rx-select__trigger');

    wrap.classList.remove('ciw-la-rx-select--open');
    if (menu) {
      menu.hidden = true;
      menu.classList.remove('ciw-la-rx-select__menu--drop-up');
      menu.style.top = '';
      menu.style.left = '';
      menu.style.width = '';

      if (menu.parentNode !== wrap) {
        wrap.appendChild(menu);
      }
    }
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    }

    if (openWrap === wrap) {
      openWrap = null;
    }
  }

  function closeAllMenus() {
    closeMenu(openWrap);
  }

  function isMenuListScroll(target) {
    if (!openWrap || !target) {
      return false;
    }

    var menu = getWrapMenu(openWrap);
    if (!menu) {
      return false;
    }

    var menuScroll = menu.querySelector('.ciw-la-rx-select__menu-scroll');
    return !!(menuScroll && (target === menuScroll || menuScroll.contains(target)));
  }

  function getMenuAnchor(wrap) {
    var col = wrap.closest('.ciw-la-rx-grid__col');
    if (col) {
      return col;
    }

    var pdField = wrap.closest('.ciw-la-pd-split__field, .ciw-la-pd-dual-split__field');
    if (pdField) {
      return pdField;
    }

    var pdSplit = wrap.closest('.ciw-la-pd-split');
    if (pdSplit) {
      return pdSplit;
    }

    return wrap;
  }

  function getMenuFieldRect(wrap) {
    var field = wrap.closest('.ciw-la-rx-grid__col-field, .ciw-la-pd-split__field, .ciw-la-pd-dual-split__field');
    return (field || wrap).getBoundingClientRect();
  }

  function positionMenu(wrap, menu) {
    var anchor = getMenuAnchor(wrap);
    var anchorRect = anchor.getBoundingClientRect();
    var fieldRect = getMenuFieldRect(wrap);

    menu.style.left = anchorRect.left + 'px';
    menu.style.width = anchorRect.width + 'px';
    menu.style.top = fieldRect.bottom - 1 + 'px';
    menu.classList.remove('ciw-la-rx-select__menu--drop-up');

    applyMenuShellStyles(menu);

    window.requestAnimationFrame(function () {
      var menuHeight = menu.offsetHeight || 180;
      var spaceBelow = window.innerHeight - fieldRect.bottom;
      var spaceAbove = fieldRect.top;

      if (spaceBelow < menuHeight + 8 && spaceAbove > spaceBelow) {
        menu.classList.add('ciw-la-rx-select__menu--drop-up');
        menu.style.top = Math.max(8, fieldRect.top - menuHeight + 1) + 'px';
      } else {
        menu.style.top = fieldRect.bottom - 1 + 'px';
      }

      applyMenuShellStyles(menu);
    });
  }

  function repositionOpenMenu() {
    if (!openWrap) {
      return;
    }

    var menu = getWrapMenu(openWrap);
    if (menu && !menu.hidden) {
      positionMenu(openWrap, menu);
    }
  }

  function buildMenuOptions(menuScroll, select, sync) {
    menuScroll.innerHTML = '';
    var total = select.options.length;

    Array.prototype.forEach.call(select.options, function (opt, index) {
      var optionBtn = document.createElement('button');
      optionBtn.type = 'button';
      optionBtn.className = 'ciw-la-rx-select__option';
      optionBtn.setAttribute('role', 'option');
      optionBtn.dataset.value = opt.value;

      var label = (opt.textContent || '').trim();
      var labelEl = document.createElement('span');
      labelEl.className = 'ciw-la-rx-select__option-label';
      labelEl.textContent = label || 'None';

      var checkEl = document.createElement('span');
      checkEl.className = 'ciw-la-rx-select__option-check';
      checkEl.setAttribute('aria-hidden', 'true');
      checkEl.textContent = '\u2713';

      optionBtn.appendChild(labelEl);
      optionBtn.appendChild(checkEl);

      if (opt.value === select.value) {
        optionBtn.classList.add('is-selected');
        optionBtn.setAttribute('aria-selected', 'true');
      }

      if (index === total - 1) {
        optionBtn.classList.add('ciw-la-rx-select__option--last');
      }

      applyOptionStyles(optionBtn);

      optionBtn.addEventListener('mouseenter', function () {
        setImportant(optionBtn, 'background', HOVER_BG);
      });

      optionBtn.addEventListener('mouseleave', function () {
        setImportant(optionBtn, 'background', '#fff');
      });

      optionBtn.addEventListener('click', function (event) {
        event.stopPropagation();

        if (select.value !== opt.value) {
          select.value = opt.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          select.dispatchEvent(new Event('input', { bubbles: true }));
        }

        sync();
        closeMenu(select.closest('.ciw-la-rx-select'));
      });

      menuScroll.appendChild(optionBtn);
    });
  }

  function openMenu(wrap, select, sync) {
    if (!wrap || !select || select.disabled) {
      return;
    }

    if (openWrap && openWrap !== wrap) {
      closeMenu(openWrap);
    }

    var menu = getWrapMenu(wrap) || wrap.querySelector('.ciw-la-rx-select__menu');
    var menuScroll = menu && menu.querySelector('.ciw-la-rx-select__menu-scroll');
    var trigger = wrap.querySelector('.ciw-la-rx-select__trigger');

    if (!menu || !menuScroll) {
      return;
    }

    buildMenuOptions(menuScroll, select, sync);

    if (menu.parentNode !== getModalRoot()) {
      getModalRoot().appendChild(menu);
    }

    wrap._ciwRxMenu = menu;
    wrap.classList.add('ciw-la-rx-select--open');
    menu.hidden = false;
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'true');
    }

    openWrap = wrap;
    applyMenuShellStyles(menu);
    positionMenu(wrap, menu);

    window.requestAnimationFrame(function () {
      positionMenu(wrap, menu);
      applyMenuShellStyles(menu);
      var selected = menuScroll.querySelector('.is-selected');
      if (selected) {
        var listRect = menuScroll.getBoundingClientRect();
        var selectedRect = selected.getBoundingClientRect();

        if (selectedRect.top < listRect.top) {
          menuScroll.scrollTop -= listRect.top - selectedRect.top;
        } else if (selectedRect.bottom > listRect.bottom) {
          menuScroll.scrollTop += selectedRect.bottom - listRect.bottom;
        }
      }
    });
  }

  function wrapSelect(select) {
    if (!isEnhanceableSelect(select)) {
      return;
    }

    if (select.closest('.ciw-la-rx-select')) {
      return;
    }

    var host = select.parentNode;
    if (!host) {
      return;
    }

    var wrap = document.createElement('div');
    wrap.className = 'ciw-la-rx-select';

    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'ciw-la-rx-select__trigger';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');

    var valueEl = document.createElement('span');
    valueEl.className = 'ciw-la-rx-select__value';

    var chevron = document.createElement('span');
    chevron.className = 'ciw-la-rx-select__chevron';
    chevron.setAttribute('aria-hidden', 'true');

    trigger.appendChild(valueEl);
    trigger.appendChild(chevron);

    var menu = document.createElement('div');
    menu.className = 'ciw-la-rx-select__menu';
    menu.hidden = true;

    var menuScroll = document.createElement('div');
    menuScroll.className = 'ciw-la-rx-select__menu-scroll';
    menuScroll.setAttribute('role', 'listbox');
    menu.appendChild(menuScroll);
    applyMenuShellStyles(menu);

    select.classList.add('ciw-la-rx-select__native');
    select.setAttribute('tabindex', '-1');
    select.setAttribute('aria-hidden', 'true');

    host.insertBefore(wrap, select);
    wrap.appendChild(trigger);
    wrap.appendChild(menu);
    wrap.appendChild(select);
    wrap._ciwRxMenu = menu;

    function sync() {
      valueEl.textContent = getDisplayText(select);
      trigger.disabled = !!select.disabled;
      wrap.classList.toggle('ciw-la-rx-select--disabled', !!select.disabled);

      if (select.disabled && wrap.classList.contains('ciw-la-rx-select--open')) {
        closeMenu(wrap);
      }
    }

    sync();

    select.addEventListener('change', sync);

    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(sync).observe(select, {
        attributes: true,
        attributeFilter: ['disabled']
      });
    }

    trigger.addEventListener('click', function (event) {
      event.stopPropagation();

      if (select.disabled) {
        return;
      }

      if (wrap.classList.contains('ciw-la-rx-select--open')) {
        closeMenu(wrap);
        return;
      }

      openMenu(wrap, select, sync);
    });
  }

  function enhanceForm(form) {
    form = form || getForm();
    if (!form || !form.querySelector('.ciw-la-manual-rx-card--mobile')) {
      return;
    }

    form.querySelectorAll('select').forEach(wrapSelect);
  }

  function scheduleEnhance() {
    ensureStyles();
    closeAllMenus();
    enhanceForm();
    window.setTimeout(enhanceForm, 0);
    window.setTimeout(enhanceForm, 200);
  }

  document.addEventListener('click', function (event) {
    if (!openWrap) {
      return;
    }

    var menu = getWrapMenu(openWrap);
    if (openWrap.contains(event.target) || (menu && menu.contains(event.target))) {
      return;
    }

    closeAllMenus();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeAllMenus();
    }
  });

  document.addEventListener(
    'scroll',
    function (event) {
      if (!openWrap) {
        return;
      }
      if (isMenuListScroll(event.target)) {
        return;
      }
      repositionOpenMenu();
    },
    true
  );

  window.addEventListener('resize', repositionOpenMenu);

  document.addEventListener('ciw-la-manual-rx:enhanced', scheduleEnhance);
  document.addEventListener('ciw-la-upload-rx:enhanced', scheduleEnhance);
  document.addEventListener('ciw-la-manual-rx:pd-synced', scheduleEnhance);
  document.addEventListener('ciw-la-contact-rx:enhanced', scheduleEnhance);
  document.addEventListener('LensAdvizor:render:manualEntryForm', scheduleEnhance);
  document.addEventListener('LensAdvizor:render:uploadForm', scheduleEnhance);
  document.addEventListener('LensAdvizor:render:contactLensForm', scheduleEnhance);

  ensureStyles();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleEnhance);
  } else {
    scheduleEnhance();
  }
})();
